function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { withTheme } from "@material-ui/core";
import { lifecycle, compose } from "recompose";
import { withTrack } from "@dpdgroupuk/react-event-tracker";
import { PageContext } from "./PageContext";
import { isMobile } from "../../utils/helpers";
export const withPageContext = Component => {
  return function WrapperComponent(props) {
    return /*#__PURE__*/React.createElement(PageContext.Consumer, null, context => /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      pageContext: context
    })));
  };
};
export const withPageSpeedDeal = ({
  speedDealActions,
  isSpeedDealMenuOpened
}) => lifecycle({
  componentDidMount() {
    let actions = speedDealActions;

    if (typeof speedDealActions === "function") {
      actions = speedDealActions(this.props);
    }

    this.props.pageContext.setSpeedDialActions(actions);
    this.props.pageContext.setSpeedDealMenuOpened(isSpeedDealMenuOpened);
    this.props.pageContext.setSpeedDialIconWithAction([]);
  },

  componentWillUnmount() {
    // always hide speed deal actions on page leaving
    this.props.pageContext.setSpeedDealMenuOpened(false);
  }

});
export const withPageHeaderMenu = ({
  headerMenuActions
}) => lifecycle({
  componentDidMount() {
    let actions = headerMenuActions;

    if (typeof headerMenuActions === "function") {
      actions = headerMenuActions(this.props);
    }

    this.props.pageContext.setHeaderMenuActions(actions);
  }

});

const withPageBackgroundImage = backgroundImage => lifecycle({
  componentDidMount() {
    if (typeof backgroundImage === "function") {
      backgroundImage = backgroundImage(this.props);
    }

    backgroundImage && this.props.pageContext.setBackgroundImage(backgroundImage);
  }

});

const withPageBackgroundOpacity = backgroundOpacity => lifecycle({
  componentDidMount() {
    if (typeof backgroundImage === "function") {
      backgroundOpacity = backgroundOpacity(this.props);
    }

    this.props.pageContext.setBackgroundOpacity(backgroundOpacity);
  }

});

const withPageTitle = title => lifecycle({
  componentDidMount() {
    if (typeof title === "function") {
      title = title(this.props);
    }

    if (title) {
      this.props.pageContext.setTitle(title);
    }
  }

});

export const withPageFooter = isFooterHidden => lifecycle({
  componentDidMount() {
    if (typeof isFooterHidden === "function") {
      isFooterHidden = isFooterHidden(this.props);
    }

    this.props.pageContext.setFooterHidden(isFooterHidden);
  }

});
export const withMobileMenuShevron = isMobileMenuShevronVisible => lifecycle({
  componentDidMount() {
    this.props.pageContext.setShevronVisible(isMobileMenuShevronVisible);
  }

});
export const withPageControl = ({
  trackable = {},
  title,
  backgroundImage,
  backgroundOpacity,
  isSpeedDealMenuOpened = !isMobile,
  isFooterHidden = false,
  headerMenuActions = [],
  speedDealActions = [],
  isMobileMenuShevronVisible = false
}) => compose(withTheme, withPageContext, withTrack(trackable), withPageTitle(title), withPageFooter(isFooterHidden), withPageBackgroundImage(backgroundImage), withPageBackgroundOpacity(backgroundOpacity), withPageHeaderMenu({
  headerMenuActions
}), withPageSpeedDeal({
  speedDealActions,
  isSpeedDealMenuOpened
}), withMobileMenuShevron(isMobileMenuShevronVisible));